import { Skeleton, Stack, useTheme } from '@mui/material'

export const JobCardSkeleton = () => {
  const theme = useTheme()
  return (
    <Stack
      sx={{
        boxShadow:
          '0 2px 4px 0 rgba(25, 23, 21, 0.03), 0 8px 8px 0 rgba(25, 23, 21, 0.02)',
        border: '1px solid',
        borderColor: theme.palette.border['brand-subtle'],
        borderRadius: '16px',
        padding: 2,
        backgroundColor: theme.palette.background.surface,
        gap: 1,
      }}
    >
      <Skeleton variant="rounded" width="40%" height={24} />

      <Stack direction="row" spacing={1}>
        <Skeleton variant="rounded" width={40} height={24} />
        <Skeleton variant="rounded" width={60} height={24} />
      </Stack>
      <Stack
        sx={{
          gap: 1,
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'flex-start',
          width: '100%',
        }}
      >
        <Skeleton variant="circular" width={20} height={20} />
        <Skeleton variant="rounded" width="20%" height={20} />
      </Stack>
    </Stack>
  )
}
